import { useState, useEffect, useRef } from "react";
import messageSound from "../../../assets/sounds/message.mp3";
import styles from "./SectionNotificationCard.module.scss";
import secondaryComponents from "..";
import primaryComponents from "../../primaryComponents";

const SectionNotificationCard = ({ event, onClose }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const soundRef = useRef(new Audio(messageSound));

  useEffect(() => {
    if (event) soundRef.current?.play().catch(() => {});
  }, [event]);

  if (!event) return null;

  const { order_id, queue_number, section_items } = event.payload ?? {};

  const handleClose = () => {
    setSelectedItem(null);
    onClose?.();
  };

  return (
    <>
      <div className={styles.sectionNotificationCard}>
        {/* Order ID */}
        <div className="d-flex justify-content-between">
          <p>Order ID :</p>
          <p className="dark--text small-text-size">{order_id}</p>
        </div>

        {/* Section items */}
        <div>
          <p>Section Items :</p>
          {section_items?.map((item) => (
            <div
              key={item?.id}
              className={styles.sectionNotificationCard__item}
            >
              <div>
                <p className="dark--text mb-0">{item?.section?.name}</p>
                <span
                  className={`smallest-text-size ${
                    item?.status === "RECEIVED"
                      ? "pending--rounded"
                      : item?.status === "IN_PROGRESS"
                        ? "in-progress--rounded"
                        : "success--rounded"
                  }`}
                >
                  {item?.status}
                </span>
              </div>

              {item?.status === "RECEIVED" && (
                <primaryComponents.Button
                  classNames="btn btn--primary"
                  style={{ padding: "0 16px", height: "36px", flexShrink: 0 }}
                  onClick={() =>
                    setSelectedItem({
                      id: item.id,
                      status: item.status,
                      order: { queue_number, id: order_id },
                    })
                  }
                >
                  Start
                </primaryComponents.Button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* SectionDetailsWidget side panel — mirrors SectionCard behaviour */}
      <secondaryComponents.SideModal
        isActive={selectedItem !== null}
        width="500px"
        closeModal={handleClose}
      >
        <secondaryComponents.SectionDetailsWidget
          sectionDetails={selectedItem}
          closeModal={handleClose}
        />
      </secondaryComponents.SideModal>
    </>
  );
};

export default SectionNotificationCard;
